import axios from "axios";

const api_url = process.env.REACT_APP_BASE_URL_ALAGAPPA_AGENCIES;


export const listShopData = async (handleError,authToken) => {
  const axiosInstances = axios.create({
    baseURL: api_url,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
  try {
    const response = await axiosInstances.get("list-shop");
   let data=response.data.results;
        return data;
  } catch (error) {
    if (error.response) {
      handleError(error.response);
    }
    throw error;
  }
};

export const addShopData = async (payload, handleError,authToken) => {
  const axiosInstance = axios.create({
    baseURL: api_url,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
  try {
    const response = await axiosInstance.post("add-shop", payload);
    return response.data.results;
  } catch (error) {
    if (error.response) {
      handleError(error.response);
    }
    throw error;
  }
};

export const updateShopData = async (payload, handleError,authToken) => {
  const axiosInstance = axios.create({
    baseURL: api_url,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
  try {
    const response = await axiosInstance.put("update-shop", payload);
    return response.data.results;
  } catch (error) {
    if (error.response) {
      handleError(error.response);
    }
    throw error;
  }
};

export const deleteShopData = async (playload, handleError,authToken) => {
  const axiosInstance = axios.create({
    baseURL: api_url,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
  try {
    const response = await axiosInstance.delete("/delete-shop", {
      data: playload,
    });
    return response.data.results;
  } catch (error) {
    if (error.response) {
      handleError(error.response);
    }
    throw error;
  }
};

export const updateShopStatus = async (payload, handleError,authToken) => {
  const axiosInstance = axios.create({
    baseURL: api_url,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  });
  try {
    const response = await axiosInstance.put("update-shop-status", payload);
      return response.data.results;
  } catch (error) {
    if (error.response) {
      handleError(error.response);
    }
    throw error;
  }
};
